module.exports = __webpack_public_path__ + "media/images/buriel-5-14a68ed207ae4fb433189c8df16a5eff.png";